export enum PACKAGE_TYPE {
  AIR_CAR = 'AIR_CAR',
  AIR_HOTEL = 'AIR_HOTEL',
  HOTEL_CAR = 'HOTEL_CAR',
  HOTEL_GROUND = 'hotel_ground_trans',
  hotel_ground_trans = 'hotel+car',
  air_car = 'flight+car',
  air_hotel = 'flight+hotel'
}

export enum INVALID_CITY_ERROR {
  invalidOriginErrMsg = 'invalidOriginErrMsg',
  invalidDestErrMsg = 'invalidDestErrMsg',
  invalidDestPkgErrMsg = 'invalidDestPkgErrMsg'
}
